import { WidgetType } from 'widgets/WidgetType';
import { AnyConfig } from 'widgets/WidgetRegistry';

export interface PendingWidgetToAdd {
    widgetType: WidgetType;
    config?: AnyConfig;
}

export default interface LayoutRendererState {
    locked: boolean;
    pendingWidgetsToAdd: PendingWidgetToAdd[];
}

export const initialLayoutRendererState: LayoutRendererState = {
    locked: true,
    pendingWidgetsToAdd: [],
};
